import { render } from "./ProductCenter.vue?vue&type=template&id=52bb97a3&scoped=true"
import script from "./ProductCenter.vue?vue&type=script&lang=js"
export * from "./ProductCenter.vue?vue&type=script&lang=js"

import "./ProductCenter.vue?vue&type=style&index=0&id=52bb97a3&lang=scss&scoped=true"

import exportComponent from "D:\\java\\code\\overseas_code\\wlxf-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bb97a3"]])

export default __exports__